import { Injectable } from '@angular/core';
import { Router, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { AuthenticationService } from '../_services/authentication.service';
import { CtrlUser } from '../../shared/_models/models';
import { environment } from '../../../environments/environment';
import { WindowService } from '../../shared/_services/window.service';

@Injectable({
  providedIn: 'root'
})
export class LoginAccessGuard  {
  constructor(
    private readonly authService: AuthenticationService,
    private readonly router: Router,
    private readonly windowService: WindowService) {
  }
  canActivate(): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    if (this.authService.currentUserValue) {
      /*
      * Currently seems to be the only solution to get the query params
      * */
      const urlParams = new URLSearchParams(window.location.search);
      if (urlParams.get('return_to')) {
        this.authService.getZendeskToken()
          .subscribe(zendeskTokenResponse => {
            const zendeskUrl = `${environment.zendeskUrl}/access/jwt?jwt=${zendeskTokenResponse.zendeskToken}`;
            this.windowService.openWindow(zendeskUrl, '_self');
          });
      }else {
        this.router.navigate(['/']);
      }
      return false;
    }
    return true;
  }

}
